import { useAuth0 } from '@auth0/auth0-react';
import styled from '@emotion/styled';
import { colors, StarOutline, StarYellow } from '@innovationdepartment/proxima-ui';
import { useProximaSDK } from 'hooks';
import type React from 'react';
import { useState } from 'react';
import LoadingSpinner from 'ui/LoadingSpinner';

type FavoriteActionProps = {
  brandId: string;
  refreshFavorites: () => void;
  isFavorite: boolean;
};

const FavoriteActionWrapper = styled.div`
  .emptystar:hover path {
    fill: ${colors.legacy.mistDarkest};
  }
`;

const BrandListFavoriteAction = ({
  brandId,
  refreshFavorites,
  isFavorite
}: FavoriteActionProps) => {
  const { user } = useAuth0();
  const usersFavoriteApi = useProximaSDK('UsersApi');

  const [loading, setLoading] = useState(false);

  const favoriteApiCall = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const userId = user?.sub;

    if (!userId) return;

    setLoading(true);
    try {
      if (isFavorite) {
        await usersFavoriteApi.deleteFavorite({ userId, userFavoriteRequest: { brandId } });
      } else {
        await usersFavoriteApi.addFavorite({ userId, userFavoriteRequest: { brandId } });
      }
    } catch {
      // TODO: Handle error
    }

    setLoading(false);
    // @ts-expect-error
    await refreshFavorites(brandId);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <FavoriteActionWrapper onClick={favoriteApiCall}>
      {isFavorite ? <StarYellow /> : <StarOutline />}
    </FavoriteActionWrapper>
  );
};

export default BrandListFavoriteAction;
